import { styled } from '@mui/system';
import { Button } from '@mui/material';
import COLORS from '../../../theme/Colors';

export const Container = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
});

export const AlcaldiaCard = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: COLORS.white,
    borderRadius: '12px',
    padding: '20px',
    boxShadow: '5px 5px 30px -10px rgba(0,0,0,0.2)',
    width: '240px',
    minHeight: '220px',
    cursor: 'pointer',
    transition: 'transform 0.2s, box-shadow 0.2s',
    '&:hover': {
        transform: 'translateY(-4px)',
        boxShadow: '5px 10px 40px -10px rgba(0,0,0,0.3)',
    },
});

export const AlcaldiaLogo = styled('img')({
    width: '60px',
    height: '60px',
    objectFit: 'contain',
    marginBottom: '12px',
    alignSelf: 'center',
});

export const AlcaldiaName = styled('p')({
    fontWeight: '700',
    fontSize: '15px',
    color: COLORS.secondary,
    margin: '0 0 8px 0',
    textAlign: 'center',
});

export const AlcaldiaInfo = styled('p')({
    fontSize: '13px',
    color: COLORS.gray,
    margin: '2px 0',
    textAlign: 'center',
});

export const AlcaldiaButton = styled(Button)({
    marginTop: '14px',
    borderRadius: '20px',
    backgroundColor: COLORS.secondary,
    color: COLORS.white,
    fontSize: '12px',
    width: '100%',
    '&:hover': {
        backgroundColor: COLORS.primary,
        color: COLORS.white,
    },
});
